<template>
    <div id="login">

      <table width="100%">
        <tr>
            <td valign="middle"><label class="string optional">Пользователь</label></td>
            <td><input v-model="input.username" id="username" style="margin-bottom: 15px;" type="text" name="username" size="30" /></td>
        </tr>
        <tr>
            <td valign="middle"><label class="string optional">Пароль </label></td>
            <td><input v-model="input.password" id="password" style="margin-bottom: 15px;" type="password" name="password" size="30" /></td>
        </tr>
        <tr>
            <td colspan='2'>
                <input id='remember_me' style='float: left; margin-right: 10px;' type="checkbox" name="remember_me" value="1" />
                <label class="string optional" for="remember_me"> Remember me</label>
            </td>
        </tr>
        <tr>
            <td colspan='2'>
              <button type="button" class="btn btn-primary" style="clear: left; width: 100%; height: 32px; font-size: 13px;" v-on:click="login()">Login</button>
              <!--<button type="button" class='btn btn-primary' style="clear: left; width: 100%; height: 32px; font-size: 13px;" v-on:click="login()">Sign In</button>-->
            </td>
        </tr>
    </table>
     <!--<table>-->
       <!--<tr>-->
         <!--<td>-->
           <!--<h1>Login</h1>-->
         <!--</td>-->
       <!--</tr>-->
       <!--<tr>-->
         <!--<td>-->
           <!--<input type="text" name="username" v-model="input.username" placeholder="Username" />-->
         <!--</td>-->
       <!--</tr>-->
       <!--<tr>-->
         <!--<td>-->
           <!--<input type="password" name="password" v-model="input.password" placeholder="Password" />-->
         <!--</td>-->
       <!--</tr>-->
       <!--<tr>-->
         <!--<td>-->
           <!--<button type="button" class="btn btn-primary" style="clear: left; width: 100%; height: 32px; font-size: 13px;" v-on:click="login()">Login</button>-->
         <!--</td>-->
       <!--</tr>-->
     <!--</table>-->
        <!--<h1>Login</h1>-->
      <!---->
        <!--<input type="text" name="username" v-model="input.username" placeholder="Username" />-->
        <!--<input type="password" name="password" v-model="input.password" placeholder="Password" />-->
        <!--<button type="button" class="btn btn-primary" style="clear: left; width: 100%; height: 32px; font-size: 13px;"v-on:click="login()">Login</button>-->
    </div>
</template>

<script>
// import qs from 'qs'
export default {
  name: 'Login',
  data () {
    return {
      input: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      // console.log(this.input.username)
      // console.log(this.input.password)
      // let uri = 'http://localhost:8000/auth/login'
      // let body = {
      //   username: this.input.username,
      //   password: this.input.password
      // }
      if ((this.input.username === 'lenobl') && (this.input.password === 'ONVTP179dx')) {
        sessionStorage.setItem('auth_token', 'dsfsagaertqrteasrgtargs')
        sessionStorage.setItem('authenticated', true)
        this.$emit('authenticated', true)
        this.$router.push({ name: 'stat' })
      }
      // this.axios({
      //   method: 'POST',
      //   headers: { 'content-type': 'application/x-www-form-urlencoded' },
      //   data: qs.stringify(body),
      //   url: uri
      // }).then((response) => {
      //   console.log(response)
      //   sessionStorage.setItem('auth_token', response.data.data.token)
      //   sessionStorage.setItem('authenticated', true)
      //   this.$emit('authenticated', true)
      //   this.$router.push({ name: 'home' })
      // }).catch((error) => {
      //   console.log(error)
      // })
    }
  }
}
</script>

<style scoped>
  #login {
    width: 450px;
    border: 1px solid #CCCCCC;
    background-color: #FFFFFF;
    margin: auto;
    margin-top: 200px;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue